import { redirect } from 'react-router-dom';

export async function requireUserSession() {
  // get the token
  const token =
    localStorage === null ? '' : localStorage.getItem('id_token') || '';
  // validate the session, `userId` is just an example, use whatever value you
  // put in the session when the user authenticated
  if (!token) {
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    const redirectUrl = `/login?redirectTo=${encodeURIComponent(
      window.location.pathname + window.location.search,
    )}`;
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw redirect(redirectUrl);
  }

  return null;
}
